import { BRAND_BLUE, brandBlueAlpha } from "@/assets/brand/colors";
import {
  GRID_PAPER_BG_IMAGE,
  GRID_PAPER_BG_SIZE
} from "../../../constants/styles";

/**
 * Every attorney-facing intake screen sits on grid paper. Re-exported under the
 * intake names so the flow keeps one canvas token, and so the client-facing
 * intake (which does not import this module) is unaffected.
 */
export const INTAKE_PAGE_BACKGROUND_IMAGE = GRID_PAPER_BG_IMAGE;

export const INTAKE_PAGE_BACKGROUND_SIZE = GRID_PAPER_BG_SIZE;

export const INTAKE_PROGRESS_TRACK = brandBlueAlpha(0.12);
export const INTAKE_PROGRESS_FILL = BRAND_BLUE;

/** Max width of the right-hand client preview panel, shared across builder screens. */
export const INTAKE_PREVIEW_PANEL_MAX_WIDTH = "560px";

/**
 * Canonical width the embedded client preview renders at before any scale-down.
 * Matches the documents table's minimum column widths (~780px) with a little
 * breathing room so text stays at full size when the panel is wide enough.
 */
export const INTAKE_PREVIEW_DESIGN_WIDTH = 800;

/**
 * Below this panel width (not viewport width), nav-bar buttons across the
 * new-intake flow collapse to icon-only. Shared so every step in the flow
 * switches at the same panel width.
 */
export const INTAKE_FOOTER_COLLAPSE_BREAKPOINT = 400;
